export default __webpack_public_path__ + "static/media/share-to-friend.f7d7725a.svg";